import { reviveDateTime } from "../../common";



export class DataStore {

    public static setData(key: string, data: any) {
        let json = JSON.stringify(data);
        localStorage.setItem(key, json);
    }

    public static getData(key: string): any {
        let json = localStorage.getItem(key);
        if (json && json !== "{}")
            return JSON.parse(json, reviveDateTime);
        return null;
    }

    public static removeData(key: string) {
        localStorage.removeItem(key);
    }

    public static keys() {
        return Object.keys(localStorage);
    }

    public static clearAll() {
        localStorage.clear();
    }
}
    

export class DataStoreKeys {
    public static ID_TOKEN = 'token';
    public static SESSION_ID = 'session-id';
    public static AUTHENTICATION_RESULT = 'authentication-result';
    public static ENVIRONMENT = 'environment';
    public static DEBUG_OPTIONS = 'debug-options';
    public static ORY_STATE = 'ory-state';
}